const PATH_URL = {
    BASE_URL: "/jws",
    GET_USER_MENU_URL: "menu/getUserMenu",
    ADD_WORK_ORDER_URL: "workOrder/addWorkOrder",

    LIST_WORK_ORDER_URL: "workOrder/listWorkOrder",
    UPDATE_WORK_ORDER_URL: "workOrder/updateWorkOrder",
    DELETE_WORK_ORDER_URL: "workOrder/deleteWorkOrder",
    HANDLE_WORK_ORDER_URL: "workOrder/handleWorkOrder",
    WORK_ORDER_UPLOAD_FILE_URL: "workOrder/uploadFile",
    EXPORT_WORK_ORDER_INFO_URL: "workOrder/exportWorkOrderInfo",
    LIST_WORK_ORDER_IDS_PAGE_URL: "workOrder/listWorkOrderIdsPage",
    TEAM_MEMBERS_QR_CODE_URL: "user/getTeamMembersCode",
    MAJOR_ACCOUNT_QR_CODE_URL: "user/getMajorAccountCode",
    GET_ACHIEVEMENT_INFO_URL: "achievement/getAchievementInfo",
    LIST_ACHIEVEMENT_INFO_URL: "achievement/listAchievement",
    LIST_COMPLETED_ORDER_INFO_URL: "achievement/listCompletedOrderInfo",
    LIST_CANCEL_ORDER_INF_URL: "achievement/listCancelAchievement",
    LIST_INVITATION_USER_INFO_URL: "achievement/listInvitationUserInfo",
    LIST_INVITATION_USER_URL: "achievement/invitationUser",
    LIST_ORDER_SUMMARY_URL: "order/listOrderSummary",
    LIST_GROUP_USER: "user/listGroupUser",
    LIST_ACHIEVEMENT_DETAILS_URL: "achievement/listAchievementDetails",
    LIST_MAJOR_ACCOUNT_INFO_URL: "operationOrTeamInfo/listMajorAccountInfo",
    LIST_MAJOR_ACCOUNT_INFO_USER_NAMES_URL: "operationOrTeamInfo/listMajorAccountInfoUserNames",
    EXPORT_MAJOR_ACCOUNT_INFO_URL: "operationOrTeamInfo/exportMajorAccountInfo",
    EXPORT_ACHIEVEMENT_INFO_URL: "achievement/exportAchievementInfo",
    LIST_TEAM_OR_OPERATOR_ACHIEVEMENT_NO_PAGE_URL: "achievement/listTeamOrOperatorAchievementNoPage",
    LIST_TEAM_OR_OPERATOR_ACHIEVEMENT_URL: "achievement/listTeamOrOperatorAchievement",
    LIST_AVERAGE_ACHIEVEMENT_URL: "achievement/listAverageAchievement",
    GET_USER_INFO_URL: "user/getUserInfo",

    SITE_LIST_ALL_NO_PAGE_URL: "site/listAllSiteNoPage",
    SITE_LIST_NO_PAGE_URL: "site/listSiteNoPage",
    SITE_SETTLE_LIST_REBATE_URL: "siteSettle/listRebate",
    SITE_SETTLE_SAVE_REBATE_URL: "siteSettle/saveRebate",
    SITE_SETTLE_DELETE_REBATE_URL: "siteSettle/deleteRebate",
    SITE_SETTLE_LIST_SETTLE_URL: "siteSettle/listSettle",
    SITE_SETTLE_LIST_SETTLE_IDS_URL: "siteSettle/listSettleIds",
    SITE_SETTLE_BATCH_DUE_URL: "siteSettle/settleDueSummary",
    SITE_SETTLE_SUMMARY_URL: "siteSettle/settleSummary",
    SITE_SETTLE_GENERATE_URL: "siteSettle/generateSettle",
    SITE_SETTLE_ASYNC_GENERATE_URL: "siteSettle/asyncGenerateSettle",
    SITE_SETTLE_GENERATE_PROGRESS_URL: "siteSettle/generateProgress",
    SITE_SETTLE_BATCH_URL: "siteSettle/batchSettle",
    SITE_SETTLE_SETTLE_ONE_URL: "siteSettle/settleOne",
    SITE_SETTLE_REVOKE_URL: "siteSettle/revokeSettle",
    SITE_SETTLE_EDIT_REMARK_URL: "siteSettle/editRemark",
    SITE_SETTLE_UPDATE_REMARK_URL: "siteSettle/updateSiteRemark",
    SITE_SETTLE_EXPORT_SETTLE_URL: "siteSettle/exportSettle",
    SITE_SETTLE_EXPORT_REBATE_URL: "siteSettle/exportRebate",
    SITE_SETTLE_STAT_URL: "siteSettle/statistics",

    BOOKKEEPING_INCOME_SAVE_URL: "bookkeeping/income/save",
    BOOKKEEPING_EXPENSE_ADD_URL: "bookkeeping/expense/add",
    BOOKKEEPING_EXPENSE_CATEGORIES_URL: "bookkeeping/expense/categories",
    BOOKKEEPING_EXPENSE_UPDATE_URL: "bookkeeping/expense/update",
    BOOKKEEPING_EXPENSE_DELETE_URL: "bookkeeping/expense/delete",
    BOOKKEEPING_MONTH_DATA_URL: "bookkeeping/monthData",
    BOOKKEEPING_MONTHLY_REPORT_URL: "bookkeeping/monthlyReport",
    BOOKKEEPING_ANNUAL_REPORT_URL: "bookkeeping/annualReport",
    BOOKKEEPING_ANNUAL_REPORT_EXPORT_URL: "bookkeeping/annualReport/export",

    SPECIAL_CHANNEL_LIST_URL: "specialChannel/list",
    SPECIAL_CHANNEL_ADD_URL: "specialChannel/add",
    SPECIAL_CHANNEL_UPDATE_URL: "specialChannel/update",
    SPECIAL_CHANNEL_DELETE_URL: "specialChannel/delete"
}
export default PATH_URL;